// src/components/ui/PaymentMethodPicker/PaymentMethodPicker.jsx
import React from 'react';
import { PaymentMethodIcon, getPaymentMethodIconUrl } from '../../../utils/paymentMethodIcons';
import styles from './PaymentMethodPicker.module.css';

/**
 * Controlled payment-method icon-row picker, shared by POS Terminal, the offline-sales
 * terminal, and Create/Edit Order's PaymentRecordsSection.
 */
const PaymentMethodPicker = ({
  methods = [],
  value,
  onSelect,
  disabled = false,
  isMethodDisabled,
  getTitle,
  size = 'md',
  className = '',
}) => {
  return (
    <div className={`${styles.methodIconRow} ${size === 'sm' ? styles.sizeSm : ''} ${className}`}>
      {methods.map((method) => {
        const label = method.label ?? method.name ?? method.key;
        const iconUrl = getPaymentMethodIconUrl(method.iconFileName);
        const methodDisabled = disabled || (isMethodDisabled ? isMethodDisabled(method) : false);
        const isSelected = value != null && value === method.key;
        const title = getTitle ? getTitle(method) : label;

        return (
          <button
            key={method.key}
            type="button"
            onClick={() => onSelect(method.key, method)}
            disabled={methodDisabled}
            title={title}
            className={`${styles.methodIconButton} ${isSelected ? styles.methodIconButtonSelected : ''}`}
          >
            {iconUrl ? (
              <PaymentMethodIcon iconFileName={method.iconFileName} label={label} />
            ) : (
              <span className={styles.methodTextChip}>{label}</span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default PaymentMethodPicker;
